import React from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

function PieChart(props) {

    // const pointFormat = () => {
    //     if(props?.format === 'currency') {
    //         return '<tr><td style="color:{series.color};padding:0"> </td>' +
    //         '<td style="padding:0"><b>R$ {point.y: .,2f} '+ (props.dadosChart.unidade?props.dadosChart.unidade:'')+'</b></td></tr>'    
    //     } else {
    //         return '<tr><td style="color:{series.color};padding:0"></td>' +
    //             '<td style="padding:0"><b>{point.y: .,0f} '+ (props.dadosChart.unidade?props.dadosChart.unidade:'')+'</b></td></tr>'
    //     }
    // }

    // let data;
    // if (props?.dadosChart?.dados) {
    //     data = props.dadosChart.dados.map((item, index) => {
    //         return { name: props.dadosChart?.labels[index], y: item }
    //     })
    // } else 
    // data = null

    const options = {
        chart: {
            backgroundColor: props?.bgColor,
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            height: props?.height || null,
        },
        credits: {
            enabled: false
        },
        title: {
            text: props?.dadosChart?.titulo
        },
        legend: {
            enabled: props?.legend || false
        },
        tooltip: {
            pointFormat: '{series.name}: <b>'+ (props?.showPercentual ? '{point.percentage:.1f}%'  : '' )+'<br />({point.y})</b>'
        },
        plotOptions: {
            series: {
                animation: false,
                events: {
                    click: props?.click || null
                }
            },
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                colors: props?.colors || ["#F3BC00", "#0075A4", "#A42F00"],
                dataLabels: {
                    enabled: props?.showLabels || false,
                    // format: "{point.name}: {point.y}",
                    // format: pointFormat(),
                    distance: 10,
                    format: '{point.percentage:.1f} %',
                    style: {
                        color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                    }
                },
                showInLegend: true
            }
        },
        series: [{
            name: '',
            colorByPoint: true,
            data: props?.dados || []
        }],
        lang: {
            noData: "Não há dados a exibir",
            contextButtonTitle: "Menu de contexto do gráfico",
            downloadCSV: "Download CSV",
            downloadJPEG: "Download JPEG",
            downloadPDF: "Download PDF",
            downloadPNG: "Download PNG",
            downloadSVG: "Download SVG",
            downloadXLS: "Download Excel",
            drillUpText: "Voltar para série principal",
            printChart: "Imprimir gráfico",
            loading: "Carregando...",
            viewData: "Ver dados em tabela",
            decimalPoint: ','
        },
        noData: {
            style: {
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#303030'
            }
        }
    }

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    )

}

export default PieChart